import React, { useEffect, useRef, useState } from "react";
import "./LossReport.scss";
import {
  CircularProgress,
  InputAdornment,
  Box,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import {
  IoIosArrowDown,
  IoIosArrowForward,
  IoIosSearch,
  IoMdClose,
} from "react-icons/io";
import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
import Header from "../../Home/Header/Header";
import CustomTextField from "../../../TextFiled/Index";

const LossReport = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [saleData, setSaleData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [expandedDepartment, setExpandedDepartment] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const gridRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (gridRef.current) {
        gridRef.current.style.height = `${window.innerHeight - 190}px`;
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setIsLoading(true);
    CommonAPImain("Report_loss")
      .then((response) => {
        if (response?.Data?.DT) {
          const formattedData = response.Data.DT.map((item, index) => ({
            ...item,
            id: index + 1,
          }));
          setFilteredData(formattedData);
          setSaleData(formattedData);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to fetch sales data. Please try again.");
        setIsLoading(false);
      });
  }, []);

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchQuery(searchValue);
    const filteredSales = saleData.filter((sale) =>
      sale.DepartmentCode.toLowerCase().includes(searchValue)
    );
    setFilteredData(filteredSales);
  };

  // Group data by DepartmentCode
  const groupedData = filteredData.reduce((acc, item) => {
    if (!acc[item.DepartmentCode]) {
      acc[item.DepartmentCode] = [];
    }
    acc[item.DepartmentCode].push(item);
    return acc;
  }, {});

  const handleDepartmentClick = (departmentCode) => {
    if (expandedDepartment === departmentCode) {
      setExpandedDepartment(null);
    } else {
      setExpandedDepartment(departmentCode); // Expand the clicked department
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredData(saleData);
  };

  return (
    <div className="employee_main">
      {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )}
      <Header otherPage={true} title="Loss Report" />
      {!isLoading &&
        (saleData?.length !== 0 ? (
          <div style={{ padding: "65px 5px 5px 5px" }}>
            <Box mb={2}>
              <CustomTextField
                className="searchBox_input"
                value={searchQuery}
                onChange={handleSearch}
                placeholder="Search ..."
                InputProps={{
                  endAdornment: searchQuery && (
                    <IconButton onClick={clearSearch}>
                      <IoMdClose className="catelog_searchClose_icone" />
                    </IconButton>
                  ),
                }}
              />
            </Box>
            <div
              ref={gridRef}
              style={{
                width: "100%",
                backgroundColor: "white",
              }}
            >
              <TableContainer style={{ marginBottom: "80px" }}>
                <Table style={{ marginBottom: "120px" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{ fontWeight: 600, width: "5%" }}
                      ></TableCell>
                      <TableCell style={{ fontWeight: 600 }}>
                        Department
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(groupedData).map((departmentCode) => (
                      <React.Fragment key={departmentCode}>
                        <TableRow
                          onClick={() => handleDepartmentClick(departmentCode)}
                          style={{ cursor: "pointer" }}
                        >
                          <TableCell>
                            {expandedDepartment === departmentCode ? (
                              <IoIosArrowDown />
                            ) : (
                              <IoIosArrowForward />
                            )}
                          </TableCell>
                          <TableCell>{departmentCode}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={2} style={{ padding: 0 }}>
                            <Collapse
                              in={expandedDepartment === departmentCode}
                              timeout="auto"
                              unmountOnExit
                            >
                              <div style={{ padding: "10px 45px" }}>
                                {groupedData[departmentCode].map(
                                  (item, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: "25px",
                                        marginBottom: "8px",
                                      }}
                                    >
                                      <span className="demartment_LocationName">
                                        {item.MFG_Locationname}
                                      </span>
                                      <span className="demartment_LocationName">
                                        {item.TotalWtLosspure}
                                      </span>
                                    </div>
                                  )
                                )}
                                {/* Total calculation and display */}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "25px",
                                    marginBottom: "8px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <span className="demartment_LocationName">
                                    Total
                                  </span>
                                  <span className="demartment_LocationName">
                                    {groupedData[departmentCode]
                                      .reduce(
                                        (total, item) =>
                                          total + item.TotalWtLosspure,
                                        0
                                      )
                                      .toFixed(3)}
                                  </span>
                                </div>
                              </div>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        ) : (
          <p
            style={{
              margin: "0px",
              paddingTop: "300px",
              textAlign: "center",
              fontSize: "15px",
            }}
          >
            No Data Available
          </p>
        ))}
    </div>
  );
};

export default LossReport;
